import { createNavigation } from "next-intl/navigation";

import { routing } from "./routing";

/**
 * next-intl provides lightweight wrappers around Next.js’ navigation APIs like
 * <Link /> and useRouter that automatically handle the user locale and pathnames behind the scenes.
 * https://next-intl.dev/docs/routing/navigation#link
 */
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
